import { render, staticRenderFns } from "./SampleModal.vue?vue&type=template&id=364b8352&scoped=true"
import script from "./SampleModal.vue?vue&type=script&lang=js"
export * from "./SampleModal.vue?vue&type=script&lang=js"
import style0 from "./SampleModal.vue?vue&type=style&index=0&id=364b8352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b8352",
  null
  
)

export default component.exports